import { render, staticRenderFns } from "./zixunEdit.vue?vue&type=template&id=204c1a13&scoped=true"
import script from "./zixunEdit.vue?vue&type=script&lang=js"
export * from "./zixunEdit.vue?vue&type=script&lang=js"
import style0 from "./zixunEdit.vue?vue&type=style&index=0&id=204c1a13&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204c1a13",
  null
  
)

export default component.exports